export default "__VITE_ASSET__DFSMZ1o0__"